<template>
	<a-dropdown
		:trigger="['click']"
		placement="bottomLeft"
		class="ml-2"
	>
		<div :class="$style.dropdown">
			<g-avatar
				:user="$gestios.profile"
				:tooltip="false"
				:size="40"
				:color="$colors['gray-6']"
			/>
		</div>
		<a-menu slot="overlay">
			<a-menu-item>
				Hola, <b>{{ $gestios.profile.Nick }}</b>
				<div>
					<b class="mr-1">Plan:</b>
					GestiOS Bronze
				</div>
			</a-menu-item>
			<a-menu-divider />
			<a-menu-item>
				<router-link
					:to="{ name: '_usersForm', params: { id: $gestios.profile.ID } }"
					class="text-light-primary"
				>
					<fa-icon
						:class="$style.menuIcon"
						:icon="['fa', 'user-edit']"
					/> Editar perfil
				</router-link>
			</a-menu-item>
			<a-menu-item>
				<a
					class="text-light-primary"
					@click="cleanCache"
				>
					<fa-icon
						:class="$style.menuIcon"
						:icon="['fa', 'hand-sparkles']"
					/> Limpiar Cache
				</a>
			</a-menu-item>
			<a-menu-item>
				<a
					class="text-light-primary"
					@click="$hub.$emit('_toggleSettings')"
				>
					<fa-icon
						:class="$style.menuIcon"
						:icon="['fa', 'palette']"
					/> Personalización
				</a>
			</a-menu-item>
			<a-menu-item>
				<a
					class="text-light-primary"
					@click="logout"
				>
					<fa-icon
						:class="$style.menuIcon"
						:icon="['fa', 'sign-out-alt']"
					/> Salir
				</a>
			</a-menu-item>
		</a-menu>
	</a-dropdown>
</template>

<script>

export default {
	data() {
		return {};
	},
	methods: {
		logout() {
			this.$gestios.auth.logout();
			this.$router.replace({ name: '_login' });
		},
		cleanCache() {
			this.$gestios.$cache.clean();
			this.$store.dispatch('queries/clean');
			this.$store.dispatch('vault/clean');
		}
	}
};
</script>

<style lang="scss" module>
@import './style.module.scss';
</style>
